module.exports = __webpack_public_path__ + "img/highlights-carousel02.279e307f.png";